<template>
  <div>
    <CRow>
      <CCol
        v-if="showMainTable"
        :md="tableColSize"
        :lg="tableColSize"
        :xl="tableColSize"
        :xxl="tableColSize"
        xs="12"
        sm="12"
      >
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Productos"
          icon="fas fa-coins"
          btn_name="Producto"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :myButtons="myButtons"
          @mtd_table_barcode="mtd_table_barcode"
          @mtd_table_price="mtd_table_price"
          @mtd_table_productUnit="mtd_table_productUnit"
          :buttonBack="true"
          :companyId="companyId"
        />
      </CCol>
      <CCol
        v-for="table in barcodeTables"
        :key="table.id"
        md="12"
        lg="12"
        xl="12"
        xxl="12"
        xs="12"
        sm="12"
      >
        <button
          @click="removeBarcodeTable(table.id)"
          class="btn btn-dark mb-1 d-flex"
        >
          <i class="fas fa-eye"></i>
          <div class="ml-2">Ocultar</div>
        </button>
        <CTableWrapper
          :items="table.data"
          :fields="table.fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          :caption="`Lista de Códigos de Barras - ${table.name_product.toUpperCase()}`"
          icon="fas fa-barcode"
          btn_name="Código"
          @mtdBack="mtdBack"
          @show_modal="mtd_barcode"
          @action_delete="mtd_delete_barcode"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="false"
          :buttonDelete="true"
          :myButtons="[]"
          :buttonBack="false"
        />
      </CCol>

      <CCol
        v-for="table in priceTables"
        :key="table.id"
        md="12"
        lg="12"
        xl="12"
        xxl="12"
        xs="12"
        sm="12"
      >
        <button
          @click="removePriceTable(table.id)"
          class="btn btn-dark mb-1 d-flex"
        >
          <i class="fas fa-eye"></i>
          <div class="ml-2">Ocultar</div>
        </button>
        <CTableWrapper
          :items="table.data"
          :fields="table.fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          :caption="`Lista de Precios - ${table.name_product}`"
          icon="fas fa-dollar-sign"
          btn_name="Precios"
          @mtdBack="mtdBack"
          @show_modal="mtd_price"
          @action_edit="mtd_show_price"
          :size="'md'"
          :button_new="false"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="false"
          :myButtons="[]"
          :buttonBack="false"
        />
      </CCol>

      <CCol
        v-for="table in productUnitTables"
        :key="table.id"
        md="12"
        lg="12"
        xl="12"
        xxl="12"
        xs="12"
        sm="12"
      >
        <button
          @click="removeProductUnitTable(table.id)"
          class="btn btn-dark mb-1 d-flex"
        >
          <i class="fas fa-eye"></i>
          <div class="ml-2">Ocultar</div>
        </button>
        <CTableWrapper
          :items="table.data"
          :fields="table.fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          :caption="`Lista de Producto x Unidad - ${table.name_product}`"
          icon="fas fa-hockey-puck"
          btn_name="Producto x Unidad"
          @mtdBack="mtdBack"
          @show_modal="mtd_productUnit"
          @action_edit="mtd_show_productUnit"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="false"
          :myButtons="[]"
          :buttonBack="false"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'lg'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="4">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="product.name"
          />
        </CCol>
        <CCol sm="4">
          <cSelectForm
            label="Marca"
            placeholder="Seleccione marca"
            :options="data_brand"
            :value.sync="product.brand_id"
          />
        </CCol>
        <CCol sm="4">
          <cSelectForm
            label="Modelo"
            placeholder="Seleccione modelo"
            :options="data_model"
            :value.sync="product.model_id"
          />
        </CCol>
        <CCol sm="12">
          <CTextarea
            col="3"
            label="Descripcion"
            v-model="product.description"
            placeholder="Digite descripcion"
          ></CTextarea>
        </CCol>
        <CCol sm="12">
          <label class="typo__label">Proveedor</label>
          <v-select
            v-model="product.provider"
            :reduce="(name) => name.id"
            :options="data_provi"
            placeholder="Seleccione varias opciones..."
            label="name"
            :close-on-select="false"
            multiple
          />
        </CCol>
        <CCol
          v-if="modal.action == 'store'"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="mb-2"
        >
          <label class="mb-2">Sedes donde registrar el producto:</label>
          <div class="campus-table-container border p-3 rounded">
            <div v-if="data_campus.length == 0" class="text-muted">
              No hay sedes disponibles
            </div>
            <table v-else class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Sede</th>
                  <!-- <th>Precio venta</th>
                  <th>Stock Mínimo</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="campus in data_campus" :key="campus.id">
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'campus-' + campus.id"
                        :value="campus.id"
                        v-model="selectedCampuses"
                        @change="toggleCampusInputs(campus.id)"
                      />
                      <label
                        class="custom-control-label"
                        :for="'campus-' + campus.id"
                      >
                        {{ campus.name }}
                      </label>
                    </div>
                  </td>
                  <!-- <td>
                    <CInput
                      type="number"
                      placeholder="Precio"
                      v-model="campusPrices[campus.id]"
                      :disabled="!isCampusSelected(campus.id)"
                      @input="validatePositiveInput(campusPrices, campus.id)"
                    />
                  </td>
                  <td>
                    <CInput
                      type="number"
                      placeholder="Stock mínimo"
                      v-model="campusStockMin[campus.id]"
                      :disabled="!isCampusSelected(campus.id)"
                      @input="validatePositiveInput(campusStockMin, campus.id)"
                      @keydown="preventDecimal"
                    />
                  </td> -->
                </tr>
              </tbody>
            </table>
            <div class="mt-2">
              <a href="#" @click.prevent="selectAllCampuses" class="mr-3"
                >Seleccionar todas</a
              >
              <a href="#" @click.prevent="deselectAllCampuses">Quitar todas</a>
            </div>
          </div>
        </CCol>
        <!-- <CCol
          v-if="modal.action != 'store'"
          xs="12"
          sm="12"
          md="6"
          lg="6"
          xl="6"
        >
          <CInput
            label="Stock Mínimo"
            type="number"
            :min="0"
            v-model="product.stock_min"
            @input="validationNumber()"
            @keydown="preventDecimal"
          />
        </CCol> -->
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="product.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal codigo de barras -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button_barcode"
      :show.sync="modal.modal_form_barcode"
      @mtd_action="mtd_action_barcode"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digete nombre"
            v-model="barcode.name"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal precios -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button_price"
      :show.sync="modal.modal_form_price"
      @mtd_action="mtd_action_price"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12" v-if="modal.action == 'update'">
          <CInput
            label="Precio de Compra"
            type="number"
            min="0"
            placeholder="Digite precio de compra"
            v-model="price.purchase_price"
            @input="calcularPrecioVenta"
          />
        </CCol>
        <template v-if="modal.action == 'update' && parseFloat(price.purchase_price) > 0">
          <CCol sm="6">
            <CInput
              label="Porcentaje (%)"
              type="number"
              min="0"
              placeholder="Digite porcentaje"
              v-model="price.percentage"
              @input="calcularPrecioVenta"
            />
          </CCol>
          <CCol sm="6">
            <CInput
              label="Precio de Venta"
              type="number"
              v-model="price.sale_price"
              :disabled="true"
            />
          </CCol>
        </template>
        <CCol sm="12" v-if="modal.action == 'update' && parseFloat(price.purchase_price) == 0">
          <CInput
            label="Precio de Venta"
            type="number"
            min="0"
            placeholder="Digite precio de venta"
            v-model="price.sale_price"
            :disabled="false"
          />
          <small class="text-muted">
            <i class="fas fa-info-circle"></i>
            Precio de compra es 0, ingrese el precio de venta manualmente.
          </small>
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal Producto x Unidad -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button_productUnit"
      :show.sync="modal.modal_form_productUnit"
      @mtd_action="mtd_action_productUnit"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <cSelectForm
            label="Unidad"
            placeholder="Seleccione unidad"
            :options="data_units"
            :value.sync="productUnit.unit_id"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Producto'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "campu_name", label: "Sede", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";
import CSwitchVue from "../../shared/switch/CSwitch.vue";

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cSelectForm,
  },
  data() {
    return {
      prefix: "products",
      fields,
      data: [],
      data_units: [],
      data_campus: [],
      data_brand: [],
      data_model: [],
      data_provi: [],
      selectedCampuses: [],
      campusPrices: {},
      campusStockMin: {},
      tableColSize: 12,
      showMainTable: true,
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Agregar Código de Barras",
          action: "mtd_table_barcode",
          icon: "fas fa-barcode",
        },
        {
          class: "btn-sm",
          color: "success",
          tooltip: "Agregar Precio",
          action: "mtd_table_price",
          icon: "fas fa-dollar-sign",
        },
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Unidad de producto",
          action: "mtd_table_productUnit",
          icon: "fas fa-hockey-puck",
        },
      ],
      modal: {
        action: "",
        title: "",
        modal_form: false,
        modal_form_barcode: false,
        modal_form_price: false,
        modal_form_productUnit: false,
      },
      product: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: "",
        name: "",
        // stock_min: 0,
        state: 0,
        campus_ids: [],
        campus_data: [],
        brand_id: null,
        model_id: null,
        description: null,
        provider: [],
      },
      barcode: {
        product_id: "",
        name: "",
        state: 0,
      },
      price: {
        product_id: "",
        sale_price: 0,
        purchase_price: 0,
        state: 0,
      },
      productUnit: {
        id: "",
        product_id: "",
        unit_id: "",
        unit: {},
        purchase_price: 0,
        sale_price: 0,
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      barcodeTables: [],
      priceTables: [],
      productUnitTables: [],
      nextBarcodeTableId: 1,
      nextPriceTableId: 1,
      nextProductUnitTableId: 1,
      companyId: this.$store.getters.get_company.id,
    };
  },
  computed: {
    cpStatus: function () {
      if (this.product.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (
        this.product.name != "" &&
        (this.modal.action != "store" || this.selectedCampuses.length > 0)
      )
        return false;
      return true;
    },
    cp_button_barcode: function () {
      if (this.barcode.name != "") return false;
      return true;
    },
    cp_button_price: function () {
      const purchase = parseFloat(this.price.purchase_price);
      const sale = parseFloat(this.price.sale_price);
      if (purchase > 0 && sale > 0) return false;   // flujo normal: compra > 0
      if (purchase == 0 && sale > 0) return false;  // flujo manual: solo precio de venta
      return true;
    },
    cp_button_productUnit: function () {
      if (this.productUnit.unit_id != "") return false;
      return true;
    },
  },
  watch: {
    selectedCampuses: {
      handler(value) {
        this.product.campus_ids = [...value];
      },
      deep: true,
    },
  },
  created() {
    this.getCampus();
    this.mtd_getdata();
    this.show_Unit();
  },
  methods: {
    ...mapActions(["get", "post"]),
    isCampusSelected(campusId) {
      return this.selectedCampuses.includes(campusId);
    },
    toggleCampusInputs(campusId) {
      if (!this.isCampusSelected(campusId)) {
        this.campusPrices[campusId] = "";
        this.campusStockMin[campusId] = "";
      } else {
        this.campusPrices[campusId] = this.campusPrices[campusId] || 0;
        this.campusStockMin[campusId] = this.campusStockMin[campusId] || 0;
      }
    },
    // validatePositiveInput(obj, key) {
    //   const value = parseInt(obj[key], 10);
    //   if (isNaN(value) || value < 0) {
    //     obj[key] = 0;
    //   }
    // },
    selectAllCampuses() {
      const allSelected =
        this.data_campus.length == this.selectedCampuses.length;
      if (allSelected) return;
      this.selectedCampuses = this.data_campus.map((campus) => {
        this.campusPrices[campus.id] = this.campusPrices[campus.id] || 0;
        this.campusStockMin[campus.id] = this.campusStockMin[campus.id] || 0;
        return campus.id;
      });
    },
    deselectAllCampuses() {
      this.selectedCampuses = [];
      this.campusPrices = {};
      this.campusStockMin = {};
    },
    // validationNumber() {
    //   const quantity = parseInt(event.target.value, 10);
    //   if (quantity < 1) {
    //     this.product.stock_min = 1;
    //   }
    // },
    // preventDecimal(event) {
    //   if (event.key == "." || event.key == ",") {
    //     event.preventDefault();
    //   }
    // },
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/indexCarbino/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          this.data.forEach((item) => {
            switch (item.state) {
              case "Activo":
                item.status = "Activo";
                break;
              case "Inactivo":
                item.status = "Inactivo";
                break;
              default:
                item.status = "Desconocido";
            }
          });
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
          this.data_brand = [];
          response.data.brand.forEach((element) => {
            this.data_brand.push({
              label: element.name,
              value: element.id,
            });
          });
          this.data_model = [];
          response.data.model.forEach((element) => {
            this.data_model.push({
              label: element.name,
              value: element.id,
            });
          });
          this.data_provi = response.data.provi;
        })
        .catch((errors) => {});
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Producto")
        : (this.modal.title = "Editar Producto");
      action == "store"
        ? (this.product = {
            id: "",
            company_id: this.$store.getters.get_company.id,
            name: "",
            state: "",
            campus_ids: [],
          })
        : (this.product = { ...this.product });
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.product.campus_data = this.selectedCampuses.map((campusId) => ({
        campus_id: campusId,
        // price: parseFloat(this.campusPrices[campusId] || 0),
        // stock_min: parseInt(this.campusStockMin[campusId] || 0, 10),
      }));
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action + "/carbino",
        token: this.$store.getters.get__token,
        params: this.product,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "Producto ya resgistrado",
              icon: "warning",
            });
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedProduct = response.data.data;
              let index = this.data.findIndex(
                (product) => product.id == updatedProduct.id
              );
              if (index != -1) {
                this.$set(this.data, index, updatedProduct);
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              modal_form_barcode: false,
              modal_form_price: false,
              modal_form_productUnit: false,
            };
            this.product = {
              id: "",
              company_id: this.$store.getters.get_company.id,
              name: "",
              state: 0,
              campus_ids: [],
              campus_data: [],
            };
            this.selectedCampuses = [];
            this.campusPrices = {};
            this.campusStockMin = {};
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.product = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      }).then((response) => {
        this.mtd_getdata();
        this.modal_delete = {
          boo: false,
          item: [],
        };
        Swal.fire({
          title: "ELIMINADO CORRECTAMENTE",
          icon: "success",
        });
      });
    },
    changeSwitch: function (payload) {
      this.product.state = payload == true ? 1 : 0;
    },
    mtd_table_barcode: function (id) {
      if (this.priceTables.length != 0) {
        this.removePriceTable(this.priceTables[0].id);
      }
      if (this.productUnitTables.length != 0) {
        this.removeProductUnitTable(this.productUnitTables[0].id);
      }
      if (this.barcodeTables.length == 1) {
        this.removeBarcodeTable(this.barcodeTables[0].id);
      }
      this.barcode.product_id = id.Id;
      this.barcode.name = "";
      this.showMainTable = false;
      if (this.nextBarcodeTableId == 1) {
        const newBarcodeTable = {
          id: this.nextBarcodeTableId,
          data: [],
          fields: [
            { key: "index", label: "Id", _style: "width:1%" },
            { key: "name", label: "Nombre", _style: "width:20%;" },
          ],
          name_product: id.name,
        };
        this.barcodeTables.push(newBarcodeTable);
        this.mtd_getdata_barcode(newBarcodeTable.id, id.Id);
        this.nextBarcodeTableId += 1;
      }
    },
    removeBarcodeTable(tableId) {
      this.nextBarcodeTableId = 1;
      this.barcodeTables = this.barcodeTables.filter(
        (table) => table.id != tableId
      );
      if (this.barcodeTables.length == 0) {
        this.showMainTable = true;
      }
    },
    mtd_barcode: function () {
      this.modal.modal_form_barcode = true;
      this.modal.title = "Agregar Codigo de Barras";
      this.barcode.name = "";
    },
    mtd_action_barcode: function () {
      let color = "success";
      let message = "";
      this.post({
        url: this.$store.getters.get__url + "/barcodes/store",
        token: this.$store.getters.get__token,
        params: this.barcode,
      })
        .then((response) => {
          message = "REGISTRADO CORRECTAMENTE";
          this.mtd_getdata_barcode(
            this.barcodeTables[0].id,
            this.barcode.product_id
          );
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            modal_form_barcode: false,
            modal_form_price: false,
            modal_form_productUnit: false,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_getdata_barcode: function (tableId, productId) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byBarcode/" +
          this.$store.getters.get_company.id +
          "/" +
          productId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          const tableIndex = this.barcodeTables.findIndex(
            (table) => table.id == tableId
          );
          if (tableIndex != -1) {
            this.$set(
              this.barcodeTables[tableIndex],
              "data",
              response.data.data
            );
            let index = 1;
            this.barcodeTables[tableIndex].data.forEach((item) => {
              item.index = index;
              index++;
            });
          }
        })
        .catch((errors) => {});
    },
    mtd_delete_barcode(item) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminarlo",
      }).then((result) => {
        if (result.isConfirmed) {
          this.post({
            url: this.$store.getters.get__url + "/barcodes/destroy",
            token: this.$store.getters.get__token,
            params: {
              id: item.id,
            },
          })
            .then((response) => {
              if (response.data) {
                const tableIndex = this.barcodeTables.findIndex(
                  (table) => table.id == this.nextBarcodeTableId - 1
                );
                if (tableIndex != -1) {
                  const barcodeIndex = this.barcodeTables[
                    tableIndex
                  ].data.findIndex((barcode) => barcode.id == item.id);
                  if (barcodeIndex != -1) {
                    this.barcodeTables[tableIndex].data.splice(barcodeIndex, 1);
                  }
                }
                Swal.fire(
                  "¡Eliminado!",
                  "El código de barras ha sido eliminado.",
                  "success"
                );
              }
            })
            .catch((error) => {
              Swal.fire(
                "Error",
                "Ocurrió un error al eliminar el código de barras.",
                "error"
              );
            });
        }
      });
    },
    mtd_table_price: function (id) {
      if (this.barcodeTables.length != 0) {
        this.removeBarcodeTable(this.barcodeTables[0].id);
      }
      if (this.productUnitTables.length != 0) {
        this.removeProductUnitTable(this.productUnitTables[0].id);
      }
      if (this.priceTables.length == 1) {
        this.removePriceTable(this.priceTables[0].id);
      }
      this.price.product_id = id.Id;
      this.price.purchase_price = 0;
      this.price.sale_price = 0;
      this.showMainTable = false;
      if (this.nextPriceTableId == 1) {
        const newPriceTable = {
          id: this.nextPriceTableId,
          data: [],
          fields: [
            { key: "index", label: "Id", _style: "width:1%" },
            { key: "unit_name", label: "Unidad", _style: "width:20%;" }, 
            {
              key: "purchase_price",
              label: "Precio de compra",
              _style: "width:20%;",
            },
            { key: "percentage", label: "Porcentaje", _style: "width:20%;" },
            {
              key: "sale_price",
              label: "Precio de venta",
              _style: "width:20%;",
            },
            { key: "lote", label: "Lote", _style: "width:20%;" },
            { key: "state", label: "Estado", _style: "width:5%;" },
          ],
          name_product: id.name,
        };
        this.priceTables.push(newPriceTable);
        this.mtd_getdata_price(newPriceTable.id, id.Id);
        this.nextPriceTableId += 1;
      }
    },
    removePriceTable(tableId) {
      this.nextPriceTableId = 1;
      this.priceTables = this.priceTables.filter(
        (table) => table.id != tableId
      );
      if (this.priceTables.length == 0) {
        this.showMainTable = true;
      }
    },
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock_transfer/getCampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data_campus = response.data;
      });
    },
    mtd_price: function (action) {
      this.modal.modal_form_price = true;
      if (action == "update") {
        this.modal.title = "Editar Precio";
        this.modal.action = action;
        
      } else {
        this.modal.title = "Agregar Precio";
        this.modal.action = "store";
        this.price.purchase_price = 0;
        this.price.sale_price = 0;
        this.price.state = 0;
      }
    },
    mtd_getdata_price: function (tableId, productId) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock/byPriceStockCarbino/" +
          this.$store.getters.get_campu.id +
          "/" +
          productId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          const tableIndex = this.priceTables.findIndex(
            (table) => table.id == tableId
          );
          if (tableIndex != -1) {
            this.$set(this.priceTables[tableIndex], "data", response.data.data);
            let index = 1;
            this.priceTables[tableIndex].data.forEach((item) => {
              console.log(item);
              item.purchase_price = parseFloat(item.purchase_price).toFixed(1);
              item.sale_price = parseFloat(item.sale_price).toFixed(1);
              item.index = index;
              index++;
            });
          }
        })
        .catch((errors) => {});
    },
    mtd_show_price: function (id) {
      this.get({
        url: this.$store.getters.get__url + "/stock/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.price = response;
          this.mtd_price("update");
        })
        .catch((errors) => {});
    },
    mtd_table_productUnit: function (id) {
      if (this.priceTables.length != 0) {
        this.removePriceTable(this.priceTables[0].id);
      }
      if (this.barcodeTables.length != 0) {
        this.removeBarcodeTable(this.barcodeTables[0].id);
      }
      if (this.productUnitTables.length == 1) {
        this.removeProductUnitTable(this.productUnitTables[0].id);
      }
      this.productUnit.product_id = id.Id;
      this.productUnit.unit_id = "";
      // this.productUnit.purchase_price = 0;
      // this.productUnit.sale_price = 0;
      this.showMainTable = false;
      if (this.nextProductUnitTableId == 1) {
        const newProductUnitTable = {
          id: this.nextProductUnitTableId,
          data: [],
          fields: [
            { key: "index", label: "Id", _style: "width:1%" },
            { key: "unit_name", label: "Unidad", _style: "width:20%;" },
            { key: "state", label: "Estado", _style: "width:5%;" },
          ],
          name_product: id.name,
        };
        this.productUnitTables.push(newProductUnitTable);
        this.mtd_getdata_productUnit(newProductUnitTable.id, id.Id);
        this.nextProductUnitTableId += 1;
      }
    },
    removeProductUnitTable(tableId) {
      this.nextProductUnitTableId = 1;
      this.productUnitTables = this.productUnitTables.filter(
        (table) => table.id != tableId
      );
      if (this.productUnitTables.length == 0) {
        this.showMainTable = true;
      }
    },
    mtd_productUnit: function (action) {
      this.modal.modal_form_productUnit = true;
      if (action == "update") {
        this.modal.title = "Editar Producto x Unidad";
        this.modal.action = action;
        // unit_id ya fue asignado en mtd_show_productUnit
      } else {
        this.modal.title = "Agregar Producto x Unidad";
        this.modal.action = "store";
        this.productUnit.unit_id = "";
        this.productUnit.purchase_price = 0;
        this.productUnit.sale_price = 0;
        this.productUnit.state = 0;
      }
    },
    mtd_action_productUnit: function () {
      let color = "success";
      let message = "";
      this.post({
        url:
          this.$store.getters.get__url + "/productsunits/carbino/" + this.modal.action,
        token: this.$store.getters.get__token,
        params: this.productUnit,
      })
        .then((response) => {
          if (this.modal.action == "store") {
            message = "REGISTRADO CORRECTAMENTE";
            this.mtd_getdata_productUnit(
              this.productUnitTables[0].id,
              this.productUnit.product_id
            );
          } else {
            let updateProductxUnit = response.data.data[0];
            let index = this.productUnitTables[0].data.findIndex(
              (productUnit) => productUnit.id == updateProductxUnit.id
            );
            if (index != -1) {
              this.$set(
                this.productUnitTables[0].data,
                index,
                updateProductxUnit
              );
            }
            message = "EDITADO CORRECTAMENTE";
            this.mtd_getdata_productUnit(
              this.productUnitTables[0].id,
              this.productUnit.product_id
            );
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            modal_form_barcode: false,
            modal_form_price: false,
            modal_form_productUnit: false,
          };
          this.productUnit = {
            id: "",
            product_id: this.productUnit.product_id,
            unit_id: "",
            unit: {},
            purchase_price: 0,
            sale_price: 0,
            state: 0,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_action_price: function () {
      let color = "success";
      let message = "";
      this.post({
        url: this.$store.getters.get__url + "/stock/" + this.modal.action,
        token: this.$store.getters.get__token,
        params: this.price,
      })
        .then((response) => {
          if (this.modal.action == "store") {
            message = "REGISTRADO CORRECTAMENTE";
            this.mtd_getdata_price(
              this.priceTables[0].id,
              this.price.product_id
            );
          } else {
            let updatedPrice = response.data.data;
            let index = this.priceTables[0].data.findIndex(
              (price) => price.id == updatedPrice.id
            );
            if (index != -1) {
              this.$set(this.priceTables[0].data, index, updatedPrice);
            }
            message = "EDITADO CORRECTAMENTE";
            this.mtd_getdata_price(
              this.priceTables[0].id,
              this.price.product_id
            );
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            modal_form_barcode: false,
            modal_form_price: false,
            modal_form_productUnit: false,
          };
          this.price = {
            id: "",
            product_id: "",
            sale_price: 0,
            purchase_price: 0,
            state: 0,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_getdata_productUnit: function (tableId, productId) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byProductUnit/" +
          this.$store.getters.get_company.id +
          "/" +
          productId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          const tableIndex = this.productUnitTables.findIndex(
            (table) => table.id == tableId
          );
          if (tableIndex != -1) {
            this.$set(
              this.productUnitTables[tableIndex],
              "data",
              response.data.data
            );
            let index = 1;
            this.productUnitTables[tableIndex].data.forEach((item) => {
              item.index = index;
              index++;
            });
          }
        })
        .catch((errors) => {});
    },
    mtd_show_productUnit: function (id) {
      this.get({
        url: this.$store.getters.get__url + "/productsunits/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // Mapear la respuesta al objeto productUnit incluyendo precios
          this.productUnit = {
            id: response.id,
            product_id: response.product_id,
            unit_id: response.unit_id || (response.unit ? response.unit.id : ""),
            unit: response.unit || {},
            purchase_price: response.purchase_price || 0,
            sale_price: response.sale_price || 0,
            state: response.state,
          };
          this.mtd_productUnit("update");
        })
        .catch((errors) => {});
    },
    show_Unit: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/productsunits/byUnit/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.data_units.push({
              label: element.name,
              value: element.id,
              quantity: element.quantity,
            });
          });
        })
        .catch((errors) => {});
    },
    validatePositive(field) {
      if (this.price[field] <= 0) {
        this.price[field] = 1;
      }
    },
    validatePositiveProductUnit(field) {
      if (this.productUnit[field] < 0) {
        this.productUnit[field] = 0;
      }
    },
    calcularPrecioVenta() {
      let purchase = parseFloat(this.price.purchase_price) || 0;
      let percentage = parseFloat(this.price.percentage) || 0;

      if (purchase < 0) purchase = 0;
      if (percentage < 0) percentage = 0;

      // Si precio de compra es 0, el precio de venta se ingresa manualmente
      if (purchase == 0) {
        this.price.percentage = 0;
        return;
      }

      let utilidad = (purchase * percentage) / 100;
      let salePrice = purchase + utilidad;

      // Redondear a 2 decimales
      this.price.sale_price = parseFloat(salePrice.toFixed(2));
    }
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>